"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AnalyticsContext = react_1.default.createContext({
    track: () => { }
});
function withAnalytics(WrapperComponent) {
    const AnalyticsWrapper = props => (react_1.default.createElement(AnalyticsContext.Consumer, null, ({ track }) => react_1.default.createElement(WrapperComponent, Object.assign({}, props, { track: track }))));
    AnalyticsWrapper.displayName = WrapperComponent.displayName;
    return AnalyticsWrapper;
}
exports.withAnalytics = withAnalytics;
class AnalyticsContextProvider extends react_1.Component {
    render() {
        return (react_1.default.createElement(AnalyticsContext.Provider, { value: { track } }, this.props.children));
    }
}
exports.AnalyticsContextProvider = AnalyticsContextProvider;
class MockAnalyticsContextProvider extends react_1.Component {
    render() {
        return (react_1.default.createElement(AnalyticsContext.Provider, { value: { track: this.props.track } }, this.props.children));
    }
}
exports.MockAnalyticsContextProvider = MockAnalyticsContextProvider;
exports.useAnalytics = () => {
    const { track } = react_1.useContext(AnalyticsContext);
    return track;
};
